var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "MobileContainer",
    [
      _c(
        "MobileHeader",
        {
          attrs: {
            slot: "header",
            "close-to": _vm.backPage,
            "nav-action": _vm.navAction
          },
          slot: "header"
        },
        [_vm._v("\n    Confirm Payment\n  ")]
      ),
      _vm._v(" "),
      _c("CheckoutPayment")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/mobile/components/MobilePaymentConfirm.vue?vue&type=template&id=215d439c&
// module id = null
// module chunks = 